import {
  styled,
  Switch as MuiSwitch,
  Typography,
  SwitchProps,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  FormGroupProps
} from "@mui/material"
import Stack from "../stack"
import React from "react"
import CheckBox from "../checkbox"
import Conditional from "../conditional"

const Switch = React.forwardRef(
  (
    {
      title,
      subtitle,
      error,
      helperText,
      variant = "switch",
      value,
      checked,
      onChange,
      switchProps,
      formGroupProps,
      disabled,
      required,
      alignItems = "center"
    }: {
      title?: string
      subtitle?: string
      error?: boolean
      helperText?: string
      variant?: "switch" | "checkbox"
      value?: boolean | null
      checked?: boolean
      onChange: (val: boolean | null) => void
      disabled?: boolean
      required?: boolean
      switchProps?: SwitchProps
      formGroupProps?: FormGroupProps
      alignItems?: "center" | "flex-start" | "flex-end"
    },
    ref?: any
  ) => {
    return (
      <>
        <Stack direction={variant === "switch" ? "row" : "column"} alignItems={alignItems}>
          <Conditional condition={variant === "switch"}>
            <StyledSwitch
              disabled={disabled}
              ref={ref}
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
              required={required}
              {...switchProps}
            />
          </Conditional>
          <Stack>
            <Typography variant="body1" fontWeight={500}>
              {title}
              {required ? (
                <FormHelperText sx={{ fontSize: "1rem", display: "inline" }} error>
                  *
                </FormHelperText>
              ) : (
                <></>
              )}
            </Typography>
            <Typography variant="subtitle1">{subtitle}</Typography>
            <Conditional condition={variant === "checkbox"}>
              <FormGroup
                onChange={(e) => console.log("e", e)}
                sx={{ flexDirection: "row", pl: 1, ...formGroupProps?.sx }}
                aria-orientation="horizontal"
                {...formGroupProps}
              >
                <FormControlLabel
                  control={
                    <CheckBox
                      size="small"
                      disabled={disabled}
                      checked={value === true}
                      onChange={(e) => onChange(e.target.checked ? true : null)}
                      name="yes"
                    />
                  }
                  label="Yes"
                />
                <FormControlLabel
                  control={
                    <CheckBox
                      disabled={disabled}
                      checked={value === false}
                      onChange={(e) => onChange(e.target.checked ? false : null)}
                      name="no"
                    />
                  }
                  label="No"
                />
              </FormGroup>
            </Conditional>
          </Stack>
          {error ? <FormHelperText error>{helperText}</FormHelperText> : <></>}
        </Stack>
      </>
    )
  }
)

export default Switch
const StyledSwitch = styled(MuiSwitch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-switchBase": {
    "&.Mui-checked": {
      color: theme.palette.background.default,
      "& + .MuiSwitch-track": {
        background: theme.palette.primary.main,
        opacity: 1
      }
    }
  },
  "& .MuiSwitch-track": {
    background: (theme.palette.neutral as any).main,
    opacity: 1,
    borderRadius: 22 / 2,

    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16
    }
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2
  }
}))
